import { useQuery } from "react-query";
import { usePublicView } from "pages/Profile/hooks/usePublicView";
import { useGetPublicProfile } from "pages/Profile/hooks/useGetPublicProfile";
import SocialMediaService from "services/SocialMediaService";
import { socialMediaWebsiteQueryKey } from "pages/MainPage/components/SocialMediaList/constants";
import { captureExceptionEvent } from "shared-services";
import type { SocialMedia } from "models/Social";

export function useGetProfileSocialMediaWebsite() {
  const { isPublicView } = usePublicView();
  const { data: publicProfileData } = useGetPublicProfile();

  const { data: privateSocialMedia, isLoading } = useQuery<
    SocialMedia | undefined
  >(
    [socialMediaWebsiteQueryKey],
    async () => {
      try {
        return await SocialMediaService.getSocialMedia();
      } catch (error) {
        captureExceptionEvent(error);

        return undefined;
      }
    },
    {
      enabled: !isPublicView,
    }
  );

  const socialMedia = isPublicView
    ? publicProfileData?.socialMedia
    : privateSocialMedia;

  return { socialMedia, isLoading };
}
